import script from "./FooterElement.vue?vue&type=script&setup=true&lang=js"
export * from "./FooterElement.vue?vue&type=script&setup=true&lang=js"

import "./FooterElement.vue?vue&type=style&index=0&id=6b5d1cab&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6b5d1cab"]])

export default __exports__